import { PortfolioBlocksInterface } from '@shared/components/trading/portfolio/core/interfaces/portfolio-blocks.interface'
import { PortfolioBlocksEnum } from '@shared/components/trading/portfolio/core/enums/portfolio-blocks.enum'

export const PortfolioBlocks: PortfolioBlocksInterface[] = [
	{ translatePath: 'portfolioBlocks.profitability', block: PortfolioBlocksEnum.PROFITABILITY },
	{ translatePath: 'portfolioBlocks.portfolioValuation', block: PortfolioBlocksEnum.PORTFOLIO_VALUATION },
	{ translatePath: 'portfolioBlocks.riskLevel', block: PortfolioBlocksEnum.RISK_LEVEL },
]
